import { render } from "./TileViewSetting.vue?vue&type=template&id=2f51cb87"
import script from "./TileViewSetting.vue?vue&type=script&lang=js"
export * from "./TileViewSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__